import { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider } from "@/components/ui/tooltip";

export function Tip({ label, children, side = "bottom" }) {
  if (!label) return children;
  return (
    <TooltipProvider delayDuration={150}>
      <Tooltip>
        <TooltipTrigger asChild>{children}</TooltipTrigger>
        <TooltipContent side={side} className="border-2 border-brand-ink bg-brand-ink text-white font-head font-bold text-xs rounded-lg shadow-none">
          {label}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
